import './src/styles/global.css';
import './src/assets/fonts/stylesheet.css';
import './src/styles/animations.css';
import './src/styles/slick.css';
import './src/styles/slick-theme.css';
